import { render, staticRenderFns } from "./RegisterStatistic.vue?vue&type=template&id=6724f1e2&"
import script from "./RegisterStatistic.vue?vue&type=script&lang=js&"
export * from "./RegisterStatistic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStatistic.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports